module.exports = __webpack_public_path__ + "Channels.0f331bb3b805be0e143e286eb987723d.hashedasset.svg";